// src/components/sites/AboutUs.js
import React from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

import '../../assets/css/about.css'

const AboutUs = () => {
  const pageTitle = 'Über Uns | NGCTV';
  const pageDescription =
    'NGCTV – seit 2012 deine Plattform für Gaming & Technik. News, Tests und Hintergründe zu PC, Konsole & Handheld – unabhängig, leidenschaftlich und mit starkem Community-Fokus.';

  return (
    <>
      {/* SEO / Head */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ngctv.de/info" />
      </Helmet>

      <main>
        <div className="wrapper">
          <div className="rows">
            <div className="row">
              <div className="category">Über Uns</div>
              <div className="about">
                <h2>Unsere Geschichte</h2>
                <p>
                  Am <strong>2. November 2012</strong> begann die Reise von NGCTV, gegründet
                  von <strong>Ralf Glende</strong>. Was damals als kleines Herzensprojekt
                  rund um Gaming und Technik startete, hat sich im Laufe der Jahre zu einer
                  lebendigen Plattform für News, Tests und Community-Austausch entwickelt.
                </p>

                <h2>Unsere Mission</h2>
                <p>
                  Von den ersten Artikeln über Xbox- und PlayStation-Highlights bis hin zu
                  tiefgehenden Hardware-Analysen und Diskussionen über die Zukunft des
                  Gamings – NGCTV hatte von Beginn an ein klares Ziel:
                  <em> authentisch, nahbar und informativ</em> zu berichten. Wir möchten
                  die Begeisterung für digitale Welten teilen und den Fokus dabei
                  gleichermaßen auf Spiele und Technik legen – sei es PC, Konsole oder
                  Handheld.
                </p>

                <h2>Die Community</h2>
                <p>
                  Die Community war von Anfang an ein zentraler Bestandteil. NGCTV wurde
                  nicht nur als News-Seite gesehen, sondern schnell auch als
                  <strong> Treffpunkt für Gamer</strong>, die ihre Eindrücke teilen,
                  diskutieren und gemeinsam Teil der Entwicklung werden wollten. Diese Nähe
                  zu den Leserinnen und Lesern prägt unsere Inhalte bis heute.
                </p>

                <h2>Heute &amp; Morgen</h2>
                <p>
                  Über die Jahre hinweg ist NGCTV gewachsen – in Themen, Reichweite und
                  Erfahrung. Doch eines ist gleich geblieben: die Leidenschaft für das,
                  worüber wir berichten.
                </p>

                <ul>
                  <li>Große Blockbuster-Releases</li>
                  <li>Kleine Indie-Überraschungen</li>
                  <li>Spannende Technik-Trends</li>
                </ul>

                <p>
                  Heute, mehr als ein Jahrzehnt nach der Gründung, ist NGCTV eine
                  <strong> feste Anlaufstelle für alle, die Gaming und Technik lieben</strong>
                  – mit dem Anspruch, nicht nur zu informieren, sondern die Faszination
                  interaktiver Unterhaltung erlebbar zu machen.
                </p>
              </div>
            </div>

            <div className="row">
              <ShortTests />
              <ShortNews />
              <AdSlot slot="2119524913" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutUs;
